<template>
    <div>
        <v-content-layout>
            <template #header>
                <FilterOption />
                <div>
                    <el-input class="ml-2" prefix-icon="el-icon-search" placeholder="Search" v-model="search" clearable></el-input>
                </div>
                <v-spacer></v-spacer>
                <el-button icon="mdi mdi-upload" type="primary" @click="handleModalView"> Import</el-button>
                <el-button class="ml-2" icon="mdi mdi-refresh" type="success" @click="loadImportLogs"> Refresh</el-button>
            </template>
            <template #body>
                <e-table :data="items" :total="items.length" :headers="headers" :search="search" :height="window.height - 170" :loading="loading">
                    <template #actions="{scope}">
                        <span v-if="scope.row.status === 1">-</span>
                        <el-dropdown size="mini" v-else trigger="click" split-button type="primary" @click="handleViewResult(scope.row)">
                            View Results
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item icon="el-icon-download" @click.native="$downloadFile(scope.row.orig_filename, scope.row.orig_file_link)">Download Original PDF</el-dropdown-item>
                                <el-dropdown-item icon="el-icon-view" @click.native="handlePDFPreview(scope.row)">Prewiew PDF</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>

                    </template>
                </e-table>
            </template>
        </v-content-layout>
        <ImportForm ref="importFormDialog" />
        <PDFPreview ref="pdfPreviewDialog" />
    </div>
</template>

<script>
import ImportForm from './components/ImportForm';
import PDFPreview from './components/PDFPreview';
import FilterOption from './components/FilterOption';

import {
    mapGetters,
    mapActions
} from 'vuex';
import * as type from '../../store/types';

export default {
    components: {
        ImportForm,
        PDFPreview,
        FilterOption
    },
    data: () => ({
        search: '',
        pdfLink: '',
        timer: ''
    }),
    computed: {
        ...mapGetters({
            headers: 'docparser/headers',
            items: 'docparser/items',
            loading: 'docparser/getLoading',
        })
    },
    mounted() {
        this.loadImportLogs({});
        this.timer = setInterval(() => {
            this.loadImportLogs({})
        }, 60000);
    },
    methods: {
        ...mapActions({
            loadImportLogs: `docparser/${type.DP_GET_PARSED_RESULT}`
        }),
        handleModalView() {
            this.$refs['importFormDialog'].handleModalView()
        },
        handlePDFPreview(row) {
            this.$refs['pdfPreviewDialog'].handlePDF(row.orig_file_link);
        },
        handleViewResult(row) {
            this.$router.push(`/parsers/${row.batch_id}?parserType=${row.parser_type}`);
        }
    }
}
</script>
